export const Routes = {
    home: '/#',
    builder: '/builder',
    login: '/login',
    about: '/about',
    changelog: '/changelog',
}